import { Box, Stack } from '@mui/material';

interface DialogActionsLayoutProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export const DialogActionsLayout = ({ left, right }: DialogActionsLayoutProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        gap: 2,
        paddingTop: 2,
        flex: 1,
      }}
    >
      {left}
      <Box
        sx={{
          flex: 1,
        }}
      ></Box>
      {right}
    </Stack>
  );
};
